import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingScreenComponent } from './loading-screen/loading-screen.component';

@NgModule({
  imports: [
    CommonModule
  ],
  exports:[
    LoadingScreenComponent
  ],
  declarations: [LoadingScreenComponent]
})
export class PreloaderModule { }
